import React, { Component } from 'react';

class ConfirmadorBloqueo extends Component {
    render() { 

        const {data,actions,tarjetaBloqueo} = this.props;

        let esBloqueo = true;
        let tituloModal = "Bloqueo de Tarjeta"
        let mensajeSuperior = "";
        let mensajeInferior = "";

        if(tarjetaBloqueo){
            esBloqueo = tarjetaBloqueo.TarjetaCreditoEstadoId == 3;

            if(esBloqueo){
                mensajeSuperior = "¿Confirma el bloqueo de la tarjeta " + tarjetaBloqueo.NumeroTarjeta + " del cliente " + tarjetaBloqueo.NombreCliente + "?";
                mensajeInferior = "Si confirma la operación se realizará el bloqueo inmediato de la tarjeta indicada";
            }else{
                tituloModal = "Desbloqueo de Tarjeta"
                mensajeSuperior = "¿Confirma el desbloqueo de la tarjeta " + tarjetaBloqueo.NumeroTarjeta + " del cliente " + tarjetaBloqueo.NombreCliente + "?";
                mensajeInferior = "Si confirma la operación se realizará el desbloqueo inmediato de la tarjeta indicada";
            }
        }

        return (  
        <div className='modaConfirmadorBloqueoInterior'>
            <div>
                {tituloModal}
            </div>
            <div className='modaConfirmadorBloqueoInteriorCuerpo'>
                <div>{mensajeSuperior}</div>
                <div>{mensajeInferior}</div>
            </div>
            <div className='modaConfirmadorBloqueoInteriorFooter'>
                <button onClick={()=>actions.modalSeccion("IntegrantesCuenta","CONFIRMADOR-BLOQUEO",false,null,"tarjetaBloqueo")} className='btn btn-secondary'>Cancelar</button>
                <button onClick={()=>actions.cambiarEstadoTarjeta(tarjetaBloqueo,(esBloqueo ? "BloqueoTemporal" : "Normal"))} className='btn btn-cta'>Aceptar</button>
            </div>
        </div>
       );
    }   
}
export default ConfirmadorBloqueo;